import styled from 'styled-components';
export const Avatar = styled.img`
    width: 50px;
    height: 50px;
    padding-left: 10px;  
    padding-right: 10px;
`
